import { DocumentNode, gql } from '@apollo/client';
import { Box, Divider, HStack } from '@chakra-ui/react';
import * as React from 'react';

import { EModItemResolutionState } from '@/client/legacy-shared-modules/moderation-item/moderationType';

import { ModerationHeader_CommentFragment } from './graphql-types/ModerationHeader_CommentFragment';

import { PendingModerationState } from './components/PendingModerationState';
import { RejectedModerationState } from './components/RejectedModerationState';

const COMMENT_FRAGMENT = gql`
  fragment ModerationHeader_CommentFragment on Comment {
    _id
    moderationItem {
      _id
      resolutionState
    }
    ...PendingModerationState_CommentFragment
  }
  ${PendingModerationState.commentFragment}
`;

export const ModerationHeader: React.FC<{
  comment: ModerationHeader_CommentFragment;
}> & {
  commentFragment: DocumentNode;
} = ({ comment }) => {
  const moderationState = comment.moderationItem?.resolutionState;

  return (
    <Box pb="2">
      <HStack alignItems="center">
        {moderationState === EModItemResolutionState.PENDING && (
          <PendingModerationState comment={comment} />
        )}
        {moderationState === EModItemResolutionState.REJECTED && (
          <RejectedModerationState />
        )}
      </HStack>
      <Divider pt="2" />
    </Box>
  );
};

ModerationHeader.commentFragment = COMMENT_FRAGMENT;
